import React, {Component} from 'react';
import request from 'superagent';
import EventListener from "react-event-listener";
import TopBar from './TopBar.js';
import SideBar from './SideBar.js';
import Footer from './Footer.js';
import GlobalConstants, {Permissions} from "../../commons/Constants.js";
import Waiting from '../../commons/Waiting';
import {permissionCtrlHOC, getUrl, superAgentWithAuth} from "../../commons/CommonUtils.js";

import TenantView from '../../modules/tenants/TenantView.js';
import MultiTenantServiceView from '../../modules/multi-tenanted-service/MultiTenantServiceView.js';
import DashboardViewAnt from '../../modules/dashboard/DashboardViewAnt.js';
import UserList from '../user/UserListView';
import PolicyList from '../policy/PolicyListView';
import Diagnostics from '../../modules/diagnostics/component/DiagnosticsViewAnt';
import PlatformInfoView from '../../modules/system-usage/PlatformInfoView.js';
import SystemUsageView from '../../modules/system-usage/SystemUsageView.js';
import KibanaDashboard from '../kibana/KibanaDashboard.js';
import AppList from '../appstore/AppList.js';

import {Route, Switch} from 'react-router-dom';
import { Spin } from 'antd';

class MainPage extends Component {

    timerId = 0;

    constructor(props) {
        super(props);
        this.state = {
            showMenu: true,
            initializing: true,
            isLoggedIn: false,
            displayName: "Cloud Service Administration",
            services: {},
            userPermissions: [],
            currentURLPath: ''
        };
        this.request = new superAgentWithAuth(this.props.history);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.request = new superAgentWithAuth(nextProps.history);
            this.checkLogin().then(() => {
                console.log("user auth check done");
            }).catch((err) => {
                this.setState({initializing: true, isLoggedIn: false});
                this.request.redirectCall();
                console.error("check login failed");
            });
        } else if (nextProps.location.pathname === '/main/dashboard' && nextProps.location.key !== undefined) {
            document.querySelector('#configuration-back-to-dashboard').click();
        }
    }

    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            console.log("----end listen.");
        }
        if (this.timerId !== 0) {
            clearTimeout(this.timerId);
            this.timerId = 0;
        }
    }

    componentDidMount() {
        this.discover()
            .then(this.checkLogin())
            .then(this.getServices)
            .then(this.checkPrivileges)
            .then(() => {
                console.log("user auth check done");

                this.unlisten = this.props.history.listen((location, action) => {
                    // location is an object like window.location
                    this.setState({currentURLPath: location.pathname});
                });
                this.setState({initializing: false, isLoggedIn: true, currentURLPath: this.props.location.pathname});
                this.startTimer();
            })
            .catch((err) => {
                if (err.message === "NO PERMISSION") {
                    this.props.history.push({
                        pathname: '/login/loginFailed',
                        state: 'Unauthorized user. Please enter the email address of an authorized user.'
                    });
                } else {
                    this.request.redirectCall();
                    console.error("check login failed. ", err);
                    throw err;
                }
            }
        );
    }

    discover = () => {
        return request.get('/api/discoverUrl')
            .withCredentials()
            .then(res => {
                sessionStorage.setItem('tenantId', res.body.tid);
                sessionStorage.setItem('uaid', res.body.uaid);
                sessionStorage.setItem('directoryUrl', res.body.serviceDirectory);
            });
    }

    checkLogin = () => {
        return request.get('/api/checkLogin').withCredentials();
    }

    getServices = () => {
        const url = sessionStorage.getItem('directoryUrl') + '?tid=' + sessionStorage.getItem('tenantId');
        return request.get(url).withCredentials()
            .then((response) => {
                let tmpServices = {};
                const services = response.body.services;
                services.forEach(ser => {
                    let service = {};
                    ser.versions.forEach(ver => {
                        service[ver.version] = ver.url;
                    })
                    tmpServices[ser.name] = service;
                })
                this.setState({services: tmpServices});
                sessionStorage.setItem('services', JSON.stringify(tmpServices));
                return tmpServices;
            })
    }

    checkPrivileges = () => {
        const url = getUrl(GlobalConstants.Service.userInfo, "/myprofile");
        return this.request.doGet(url).withCredentials()
            .then((response) => {
                const profile = response.body;
                if (profile.permissions === undefined || profile.permissions.length === 0) {
                    throw Error("NO PERMISSION");
                }
                let displayName = "";
                if (profile.localProf) {
                    if (profile.localProf.fname) {
                        displayName += profile.localProf.fname + " ";
                    }
                    if (profile.localProf.lname) {
                        displayName += profile.localProf.lname;
                    }
                    this.setState({displayName: displayName});
                }
                const userPermissions = profile.permissions;

                sessionStorage.setItem('username', profile.email);
                sessionStorage.setItem('uuid', profile.uuid);
                sessionStorage.setItem('isLocalUser', profile.isLocalUser);
                sessionStorage.setItem(GlobalConstants.SessionStoreKey.Permission, JSON.stringify(userPermissions));
                this.setState({userPermissions: userPermissions, userProfile: profile});
            });
    }

    refreshUserProfileIfNeed = (email) => {
        console.log("in refreshUserProfileIfNeed. " + email);
        if ((email && email === this.state.userProfile.email) || !this.state.userProfile) {
            this.checkPrivileges().catch((err) => {
                console.error("fail to refresh user profile, cause by:", err.message);
            });
            this.render();
        }
    }

    toggle = () => {
        this.setState({showMenu: !this.state.showMenu});
    }

    logUserOut = () => {
        console.log("user logout");
        const url = getUrl(GlobalConstants.Service.orionUserAuth, "/signout");

        request.delete('/api/removeAuthCookie').withCredentials()
            .then(() => {
                request.post(url).withCredentials().end();
            }).catch((err) => {
                console.error(`logout error: ${err}`);
            });
        this.props.history.push('/login');
        sessionStorage.clear();
    }

    /**
     * Starts a 1hr session timer.
     */
    startTimer = () => {
        if (this.timerId === 0) {
            this.timerId = setTimeout(this.logUserOut, 59 * 60 * 1000);
        }
    };

    /**
     * Resets the session timer.  Triggered on clicks.
     */
    resetTimer = () => {
        clearTimeout(this.timerId);
        this.timerId = 0;
        this.startTimer();
    };

    render() {
        const {showMenu, initializing, isLoggedIn, displayName, userPermissions, currentURLPath} = this.state;
        const menuWidth = showMenu ? "250px" : "50px";
        return (
            <div>
                {(initializing || !isLoggedIn) ? (
                    <Waiting/>
                ) : (
                    <div>
                        <EventListener target={document} onClick={this.resetTimer} />
                        <TopBar displayName={displayName} toggle={this.toggle} showMenu={showMenu}
                                logout={this.logUserOut}/>

                        <div className="ts-main-content">
                            <SideBar userPermissions={userPermissions} currentURLPath={currentURLPath}
                                     showMenu={showMenu} width={menuWidth} configs={this.props.configs}/>

                            <div className="content-wrapper" style={{"marginLeft": menuWidth}}>
                                <Switch>
                                    {permissionCtrlHOC([Permissions.SoftwareUpgrade.SHOW], userPermissions)(
                                        <Route exact path="/main/upgrade-policy" component={PolicyList}/>)}
                                    {/*<Route exact path="/main/upgrade-new-policy" component={PolicyGrid}/>*/}

                                    {permissionCtrlHOC([Permissions.TenantManager.SHOW], userPermissions)(<Route
                                        exact path="/main/tenant" component={TenantView}/>)}

                                    <Route path="/main/dashboard" component={DashboardViewAnt}/>
                                    <Route path="/main/kibana" component={KibanaDashboard}/>
                                    {permissionCtrlHOC([Permissions.MultiTenant.SHOW], userPermissions)(<Route
                                        path="/main/mutitenantedservice" component={MultiTenantServiceView}/>)}
                                    <Route path="/main/platformInfo" component={PlatformInfoView}/>
                                    {permissionCtrlHOC([Permissions.SystemUsage.SHOW], userPermissions)(<Route
                                        exact path="/main/systemUsage" component={SystemUsageView}/>)}
                                    {permissionCtrlHOC([Permissions.Diagnostics.SHOW], userPermissions)(<Route
                                        exact path="/main/diagnostics" component={Diagnostics}/>)}
                                    {permissionCtrlHOC([Permissions.User.SHOW], userPermissions)(<Route exact
                                                                                                        path="/main/user"
                                                                                                        render={(props) => <UserList refreshUserProfile={this.refreshUserProfileIfNeed} />}/>)}
                                    {permissionCtrlHOC([Permissions.AppVault.SHOW], userPermissions)(<Route
                                        path="/main/app-mgmt" component={AppList}/>)}
                                    <Route component={DashboardViewAnt}/>
                                </Switch>
                                <Footer left={menuWidth}/>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default MainPage;


// WEBPACK FOOTER //
// ./src/modules/main/MainPage.js